import { useChartLayoutObserver } from "@result/rui/hooks";
import ReactECharts from "echarts-for-react";
import { useMemo, useRef } from "react";

import { BreedingValuesChartOptions } from "#/pages/breeding-values/BreedingValuesPage.jsx";

const BreedingValuesLineChart = ({ data, title, labelX, labelY }) => {
  const { A, B } = BreedingValuesChartOptions.groups;

  const chartRef = useRef();
  useChartLayoutObserver(chartRef.current);

  const options = useMemo(() => {
    return {
      title: {
        text: title,
        left: "left",
        top: 0,
        textStyle: {
          color: BreedingValuesChartOptions.titleColor,
        },
      },
      grid: {
        top: 60,
        bottom: 80,
        left: labelY == null ? 0 : 30,
        right: 5,
        containLabel: true,
      },
      tooltip: {
        trigger: "axis",
        position: "inside",
        axisPointer: {
          type: "line",
          label: {
            show: true,
            color: "#FFFFFF",
            backgroundColor: "#17A1FA",
          },
        },
      },
      legend: {
        data: [A.key, B.key],
        selected: {
          [A.key]: true,
          [B.key]: true,
        },
        bottom: 0,
      },
      xAxis: {
        type: "category",
        name: labelX,
        nameLocation: "middle",
        nameGap: 20,
        boundaryGap: true,
        data: data.x,
      },
      yAxis: {
        type: "value",
        name: labelY,
        nameLocation: "middle",
        nameRotate: 90,
        nameGap: 40,
      },
      series: [
        {
          name: A.key,
          type: "line",
          smooth: true,
          data: data.y.A,
          symbol: "circle",
          symbolSize: 10,
          itemStyle: {
            color: A.color,
            borderColor: "#FFFFFFCC",
            borderWidth: 2,
          },
          lineStyle: {
            color: A.color,
            width: 4,
          },
          label: {
            show: true,
            color: A.color,
          },
        },
        {
          name: B.key,
          type: "line",
          smooth: true,
          data: data.y.B,
          symbol: "circle",
          symbolSize: 10,
          itemStyle: {
            color: B.color,
            borderColor: "#FFFFFFCC",
            borderWidth: 2,
          },
          lineStyle: {
            color: B.color,
            width: 4,
          },
          label: {
            show: true,
            color: B.color,
          },
        },
      ],
      dataZoom: BreedingValuesChartOptions.options.dataZoom,
    };
  }, [chartRef.current]);

  return (
    <ReactECharts
      option={options}
      ref={chartRef}
      notMerge={true}
      lazyUpdate={false}
    />
  );
};

export default BreedingValuesLineChart;
